<template>
  <div>
    <h1>Coming Soon!</h1>
    <v-skeleton-loader
      :loading="true"
      height="800"
      type="card-avatar, article, actions"
    />
  </div>
</template>

<script>
import titleMixin from "@/mixins/titleMixin"
export default {
  mixins: [titleMixin],
  data: function() {
    return { title: "Distribution Request" }
  }
}
</script>
